import {
  Component,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  HostListener,
} from '@angular/core';
import { GlobalUtilityService } from '../../services/global-utility.service';
import { Subscription } from 'rxjs';
import { LocalStorageDataModel } from '@AppCore/constants/local-storage-data-model';
import { SharedService } from '@AppRoot/shared/services/shared.service';
import { APIResponse } from '@AppRoot/shared/models/api-response.interface';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  @Output() menuClick = new EventEmitter();
  isLoggedIn = false;
  private subscription: Subscription = new Subscription();
  cartItemCount: number = 0;
  category: Array<{ id: number; color: string; name: string; img: string }> =
    [];

  @Output() cartOpen = new EventEmitter<void>();

  @ViewChild('scrollContainer') scrollContainer!: ElementRef;

  isSearchOpen = false;

  constructor(
    private _globalutilityService: GlobalUtilityService,
    private _sharedService: SharedService
  ) {
    this.subscription.add(
      this._globalutilityService.getLoginStatus().subscribe((status) => {
        this.isLoggedIn = status;
      })
    );
    this.subscription.add(
      this._sharedService.getCartItemCount().subscribe((count: number) => {
        this.cartItemCount = count;
      })
    );
  }

  ngOnInit() {
    this._sharedService.categoryList.subscribe((res: any) => {
      this.category = res;
    });
    this._sharedService.cartItemCount.subscribe((count: number) => {
      this.cartItemCount = count;
    });
    this._sharedService.getLogos();
  }

  openSearch() {
    this._sharedService.searchOpen.next(true);
  }

  openCart(){
    this.cartOpen.emit();

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  toggleSidebar() {
    this.menuClick.emit();
  }

  logout() {
    this._globalutilityService.logOut();
    location.reload();
    this._globalutilityService.setLoginStatus(false);
  }

  redirectToProduct(category_id: number) {
    this._globalutilityService.navigateToPath(`/products`, { category_id });
  }

  scrollLeft() {
    this.scrollContainer.nativeElement.scrollBy({
      left: -200,
      behavior: 'smooth',
    });
  }

  scrollRight() {
    this.scrollContainer.nativeElement.scrollBy({
      left: 200,
      behavior: 'smooth',
    });
  }
}
